import { apiFetch } from '../../auth/api/apiFetch.js';

export async function processMeterChangeBatch(payload, signal) {
  // payload: { fileName, batchIndex, totalBatches, rows }
  const res = await apiFetch('/api/meters/modify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    signal
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json?.error || `Failed to process batch (HTTP ${res.status})`);
  return json;
}
